'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatus = exports.getData = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getData = exports.getData = (0, _getIn2.default)(_keyPaths.DATA);

var getStatus = exports.getStatus = (0, _getIn2.default)(_keyPaths.STATUS);